var styles = {"actions":"styles_actions__1oNhP flex col-12 md-col-6 mx-auto","placement-modal":"styles_placement-modal__jiJRD","placementModal":"styles_placement-modal__jiJRD","back-button":"styles_back-button__1mU0w","backButton":"styles_back-button__1mU0w"};

export default styles;
//# sourceMappingURL=styles.css.js.map
